module.exports = __webpack_public_path__ + "img/theodore-alexander-tablet-compressed.80c28eb.png";